const PinCircleSidebar = (props: { fill: string}) => {
    return (
<svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<ellipse cx="10.4426" cy="11" rx="10.4426" ry="11" fill={props.fill}/>
</svg>
    )
}

export default PinCircleSidebar;